import React, { useId } from 'react';
import { Text, Link, mergeClasses } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useContactsPanelStyles } from './ContactsPanel.styles';
import type { ContactLink } from '@config/footerConfig';

export interface ContactsPanelProps {
  contacts: ContactLink[];
  className?: string;
}

export const ContactsPanel: React.FC<ContactsPanelProps> = ({ contacts, className }) => {
  const { t } = useTranslation('header');
  const styles = useContactsPanelStyles();
  const titleId = useId();

  if (!contacts || contacts.length === 0) return null;

  return (
    <aside className={mergeClasses(styles.root, className)} aria-labelledby={titleId}>
      <Text as="h3" id={titleId} className={styles.title}>
        {t('helpPanel.contacts.title')}
      </Text>
      <ul className={styles.list}>
        {contacts.map((contact) => {
          const href = contact.type === 'email' ? `mailto:${contact.target}` : contact.target;
          const isUrl = contact.type === 'url';
          return (
            <li
              key={`${contact.descriptionKey}::${contact.linkLabelKey}`}
              className={styles.linkItem}
            >
              <span className={styles.contactRow}>
                <Text className={styles.contactLabel}>{t(contact.descriptionKey)} </Text>
                <Link
                  className={styles.contactValue}
                  href={href}
                  {...(isUrl && { target: '_blank', rel: 'noopener noreferrer' })}
                >
                  {t(contact.linkLabelKey)}
                </Link>
              </span>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

ContactsPanel.displayName = 'ContactsPanel';
